import { SessionManager } from '@cobliteam/api-lib';
import { Environment } from '@cobliteam/react-environments';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

const env = Environment.getInstance().getEnvironment();

// Lazy instantiation to avoid circular dependency issues
const getSessionManager = () => new SessionManager({ host: env.herbieApiHost });

const QUERY_KEY = 'LOGIN';
const QUERY_KEY_SSO_TOKEN = 'SSO_TOKEN';
const QUERY_KEY_INTERCOM_JWT = 'INTERCOM_JWT';

// Intercom JWT expires in 24h. Cache for ~23h so we don't refetch on every
// remount, and disable refetch-on-focus since the token doesn't go stale on
// tab switches.
const INTERCOM_JWT_STALE_TIME = 23 * 60 * 60 * 1000;

const useGetHubSpotSSOToken = (options?: Partial<UseQueryOptions<string>>) => {
  return useQuery<string>({
    queryKey: [QUERY_KEY, QUERY_KEY_SSO_TOKEN],
    queryFn: () => getSessionManager().getHubSpotSSOToken(),
    ...options,
  });
};

const useGetIntercomJWT = (options?: Partial<UseQueryOptions<string>>) => {
  return useQuery<string>({
    queryKey: [QUERY_KEY, QUERY_KEY_INTERCOM_JWT],
    queryFn: () => getSessionManager().getIntercomJWT(),
    staleTime: INTERCOM_JWT_STALE_TIME,
    refetchOnWindowFocus: false,
    ...options,
  });
};

export { useGetHubSpotSSOToken, useGetIntercomJWT };
